<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <p class="page_title"> 커뮤니티 </p>
                <form id="write_form">
                    <p class="write_form_txt">해당 글은 익명이 보장된 게시글입니다.</p>
                    <input type="text" id="wr_title" placeholder="제목" v-model="state.title">
                    <textarea id="wr_cotnent" placeholder="내용을 입력하세요" v-model="state.content"></textarea>
                    <div class="form_btns">
                        <button @click="SaveBtn" class="submit_btn">작성완료</button>
                        <router-link to="#" @click="backList" class="cancle_btn">취소</router-link>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose">
    </ModalComponent>
    <GnbLayout></GnbLayout>
</template>
<script lang="ts" config>

import {
    reactive,
    globalStore,
    ref,
    onMounted,
    router,
    apiService,
    ModalComponent,
    HeaderLayout,
    GnbLayout,
    res,
} from "@/BaseComponent";

export default {
    props: {},
    components: {
        ModalComponent,
        HeaderLayout,
        GnbLayout,
    },

    setup() {
        const state = reactive({
            title: "" as string,
            content: "" as string,
            contentIdx: "" as string,
            writeType: 0 as number,
            isNavOpen: true,
            isModalOpen: false,
        });

        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
            actionCode: 0 as number
        });
        const global = globalStore();

        onMounted(() => {
            state.isNavOpen = global.isNavOpen;
            if (history.state.title) {
                state.title = history.state.title.replace(/&nbsp;/g, ' ');
            }
            if (history.state.content) {
                state.content = history.state.content.replace(/&nbsp;/g, ' ').replace(/<br>/g, '\n').replace(/<\/br>/g, '\n');
            }
            if (history.state.idx) {
                state.contentIdx = history.state.idx;
                state.writeType = 1;
            }
        });

        const backList = () => {
            router.back();
        };
        const SaveBtn = () => {
            state.isModalOpen = true;
            if (state.title !== "" && state.content !== "") {
                modal.content = "게시글을 등록하시겠습니까?";
                modal.confirm = "확인";
                modal.cancel = '취소';
                modal.actionCode = 2;
            } else {
                modal.content = "제목과 내용을 확인해주세요";
                modal.confirm = "확인";
                modal.cancel = '';
                modal.actionCode = 0;
            }
        };

        const writeSave = async () => {
            const tempContent = state.content.replace(/ /g, '&nbsp;');
            const tempTitle = state.title.replace(/ /g, '&nbsp;');
            let response = {} as any;
            switch (state.writeType) {
                case 0:
                    response = await apiService.community.add(tempTitle, tempContent);
                    break;
                case 1:
                    response = await apiService.community.modifyContent(state.contentIdx, tempTitle, tempContent);
                    break;
                default:
                    break;
            }
            if (response.returnCode === 0) {
                modal.content = "작성이 완료 되었습니다.";
                modal.confirm = "확인";
                modal.cancel = "";
                modal.actionCode = 1;
                state.isModalOpen = true;
            } else {
                console.error(response.description);
                modal.content = response.description;
                modal.confirm = "";
                modal.cancel = "확인";
                state.isModalOpen = true;
            }
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            if (result) {
                switch (modal.actionCode) {
                    case 1:
                        router.back();
                        break;
                    case 2:
                        writeSave();
                        break;

                    default:
                        break;
                }
            }
        };

        return {
            state,
            ref,
            SaveBtn,
            modal,
            backList,
            modalClose,
        };
    },
};
</script>
<style scoped>
.btn_wrap>button {
    margin: 10px;
}
</style>
